

export const getEditID = (state) => state.editShapeID
export const getAppliedShapes = (state) => state.supervisorResultObject.appliedShapes
export const getSubtask = (state) => state.subtask
export const getSupervisorAnswerObject = (state) => state.supervisorResultObject
export const getIsRequestApproval = (state) => state.isRequestApprove
